<template>
  <div>
    <img
      v-if="brand == 'ulu'"
      :style="logo"
      src="@/assets/uluLogo.png"
      alt="ULU logo"
    />
    <img
      v-else-if="brand == 'ulubv'"
      :style="logo"
      src="@/assets/ulubv_logo.png"
      alt="ULU BV logo"
    />
    <img
      v-else-if="brand == 'uluuk'"
      :style="logo"
      src="@/assets/uluuk_logo.png"
      alt="ULU BV logo"
    />
    <img
      v-else-if="brand == 'fleetify'"
      :style="logo"
      src="@/assets/fleetifyLogo.png"
      alt="Fleetify logo"
    />
    <img
      v-else-if="brand == 'cartracker'"
      :style="logo"
      src="@/assets/cartrackerLogo.png"
      alt="Cartracker logo"
    />
    <img
      v-else-if="brand == 'traksi'"
      :style="logo"
      src="@/assets/traksi_logo.png"
      alt="Traksi logo"
    />
    <img
      v-else-if="brand == 'requre'"
      :style="logo"
      src="@/assets/requre_logo.png"
      alt="Requre logo"
    />
    <img
      v-else-if="brand == 'finnik'"
      :style="logo"
      src="@/assets/finnik_logo.png"
      alt="Finnik logo"
    />
    <img
      v-else-if="brand == 'national_netherlands'"
      :style="logo"
      src="@/assets/ohra_logo.png"
      alt="Ohra logo"
    />
    <img
      v-else-if="brand == 'imoto'"
      :style="logo"
      src="@/assets/imoto_logo.png"
      alt="iMoto logo"
    />
  </div>
</template>

<script>
export default {
  props: {
    brand: {
      type: String,
      default: "ulu"
    },
    scale: {
      type: String,
      default: "2"
    }
  },
  computed: {
    logo() {
      return `height: ${this.scale}em;`
    }
  }
};
</script>

<style scoped>
.logo {
  height: 2em;
}
</style>
